import { h } from 'preact';

const ReturnBack = ({ 
  text = "Вернуться к сведениям об образовательной организации", 
  url = "/info" 
}) => {
  return (
    <div main-attr>
      <a
        href={url}
        style={{
          fontSize: '20px',
          paddingBottom: '30px',
          marginTop: '-0px',
          display: 'block'
        }}
      >
        {text}
      </a>
    </div>
  );
};

export default ReturnBack;
